/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckErrorContainer } from './PaxCheckErrorContainer';
import {
    PaxCheckErrorContainerFromJSON,
    PaxCheckErrorContainerFromJSONTyped,
    PaxCheckErrorContainerToJSON,
    PaxCheckErrorContainerToJSONTyped,
} from './PaxCheckErrorContainer';
import type { PaxCheckStartWithBookingIdAndSurnameResponseData } from './PaxCheckStartWithBookingIdAndSurnameResponseData';
import {
    PaxCheckStartWithBookingIdAndSurnameResponseDataFromJSON,
    PaxCheckStartWithBookingIdAndSurnameResponseDataFromJSONTyped,
    PaxCheckStartWithBookingIdAndSurnameResponseDataToJSON,
    PaxCheckStartWithBookingIdAndSurnameResponseDataToJSONTyped,
} from './PaxCheckStartWithBookingIdAndSurnameResponseData';

/**
 * Response to login with booking identifier and surname
 * @export
 * @interface PaxCheckStartWithBookingIdAndSurnameResponse
 */
export interface PaxCheckStartWithBookingIdAndSurnameResponse {
    /**
     * 
     * @type {PaxCheckStartWithBookingIdAndSurnameResponseData}
     * @memberof PaxCheckStartWithBookingIdAndSurnameResponse
     */
    data?: PaxCheckStartWithBookingIdAndSurnameResponseData;
    /**
     * 
     * @type {PaxCheckErrorContainer}
     * @memberof PaxCheckStartWithBookingIdAndSurnameResponse
     */
    error?: PaxCheckErrorContainer;
}

/**
 * Check if a given object implements the PaxCheckStartWithBookingIdAndSurnameResponse interface.
 */
export function instanceOfPaxCheckStartWithBookingIdAndSurnameResponse(value: object): value is PaxCheckStartWithBookingIdAndSurnameResponse {
    return true;
}

export function PaxCheckStartWithBookingIdAndSurnameResponseFromJSON(json: any): PaxCheckStartWithBookingIdAndSurnameResponse {
    return PaxCheckStartWithBookingIdAndSurnameResponseFromJSONTyped(json, false);
}

export function PaxCheckStartWithBookingIdAndSurnameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckStartWithBookingIdAndSurnameResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckStartWithBookingIdAndSurnameResponseDataFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckErrorContainerFromJSON(json['error']),
    };
}

export function PaxCheckStartWithBookingIdAndSurnameResponseToJSON(json: any): PaxCheckStartWithBookingIdAndSurnameResponse {
    return PaxCheckStartWithBookingIdAndSurnameResponseToJSONTyped(json, false);
}

export function PaxCheckStartWithBookingIdAndSurnameResponseToJSONTyped(value?: PaxCheckStartWithBookingIdAndSurnameResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckStartWithBookingIdAndSurnameResponseDataToJSON(value['data']),
        'error': PaxCheckErrorContainerToJSON(value['error']),
    };
}

